import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Generated from './components/Generated';
import { measureNameImage, NameImage } from './utils/signatureAssets';

const GeneratedPage = () => {
	const [query] = useSearchParams();
	const navigate = useNavigate();

	const name = query.get('name');
	const occupation = query.get('occupation');
	const phone = query.get('phone');
	const email = query.get('email');
	const publicId = query.get('public-id');

	const isComplete = [name, occupation, phone, email].every((value) => Boolean(value?.trim()));

	const [nameImage, setNameImage] = useState<NameImage | null>(null);

	useEffect(() => {
		if (!isComplete) {
			navigate('/');
		}
	}, [navigate, isComplete]);

	useEffect(() => {
		if (!name) {
			return;
		}

		let active = true;

		void measureNameImage(name).then((image) => {
			if (active) {
				setNameImage(image);
			}
		});

		return () => {
			active = false;
		};
	}, [name]);

	// The redirect above runs in an effect, so after the first render. Without
	// this guard Generated would render with missing values and throw.
	if (!isComplete) {
		return null;
	}

	return (
		<Generated
			name={name as string}
			email={email as string}
			occupation={occupation as string}
			phone={phone as string}
			publicId={publicId as string}
			nameImage={nameImage}
		/>
	);
};

export default GeneratedPage;
